import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem('language') || 'en'

const i18n = createI18n({
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    de
  }
})

export default i18n 